import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTaskCreate,
  detail: routeTaskDetail,
  home: routeTasksHome,
  root: routeTasksRoot,
} = createDoctypeRoutes({
  createName: 'new-task',
  createPath: 'new-task',
  detailName: 'taskDetail',
  doctype: DOCTYPES.TASK,
  homeName: 'tasks',
  path: 'tasks',
  views: {
    create: async () => await import('@/components/viewsExternal/tasks/AddTask.vue'),
    detail: async () => await import('@/components/viewsExternal/tasks/ViewTask.vue'),
    list: async () => await import('@/components/viewsExternal/tasks/TaskView.vue'),
  },
})

export { routeTaskCreate, routeTaskDetail, routeTasksHome, routeTasksRoot }
